import {Worker, array_remove} from "../util";
import angular from "angular";
import ListViewCtrl from "../util/ListViewCtrl";

export default class UzivatelListCtrl extends ListViewCtrl {
  
  static $inject = ["itemSource", "UzivatelService", "$window", "odberatelia"];
  constructor(itemSource, UzivatelService, $window, odberatelia){
    super(itemSource);
    this.UzivatelService = UzivatelService;    
    this.window = $window;
    this.odberatelia = odberatelia;
   
    this.newUser = {};
    this.role = [];
    this.add = Worker(this._add);
    this.UzivatelService.listRole().then(role => this.role = role);
  }

  enable(user){
    return this.UzivatelService.enable(user.id).then(u => angular.copy(u, user));
  }
 
  disable(user){
    return this.UzivatelService.disable(user.id).then(u => angular.copy(u, user));
  }

  passwordDialog(user){
    var result = this.window.prompt("Nové heslo pre užívateľa "+user.meno);
    if(result){
      return this.UzivatelService.setPassword(user.id, result).then(
        ok => this.window.alert("Heslo bolo zmenené"),
        err => this.window.alert("Chyba! Zmena sa nepodarila.")
      );
    }
  }

  reactivate(user){
    var result = this.window.confirm("Naozaj vygenerovať nové prístupové údaje pre konto "+user.email + " ?");
    if(result){
      return this.UzivatelService.reactivate(user.id).then(
        ok => this.window.alert("Aktivačný e-mail bol odoslaný"),
        err => this.window.alert("Chyba!")
      );
    }
  }

  create(){
    return this.UzivatelService.save(this.newUser)
      .then(() => this.newUser = {})
      .then(() => this.itemSource.load());
  }

  save(user){
    return this.UzivatelService.save(user).then(u => angular.copy(u, user));
  }


}


// WEBPACK FOOTER //
// ./src/Uzivatel/UzivatelListCtrl.js